/**
 * Created by Claude on 13.02.2026
 */

const IslandDecorationChest = function (mission) {
    return Prefab.instantiate(bundles.merge.jsons.island_decoration_chest_prefab_json, { mission });
};

IslandDecorationChest.createOnScene = function (mission) {
    const scene = cleverapps.Scenes.GetRunningScene();

    if (scene.islandDecorationChest) {
        return;
    }

    const chest = scene.islandDecorationChest = new IslandDecorationChest(mission);

    const control = new cc.Node();
    control.addChild(chest);
    control.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 1);
    scene.addChild(control);

    ComponentMap.attach(control, new HidingComponent({
        direction: HidingComponent.DIR.HORIZONTAL,
        control: chest.propertySource.getChestControl(),
        hiddenByDefault: [cleverapps.Environment.SCENE_MAIN]
    }));
};

IslandDecorationChest.removeFromScene = function () {
    const scene = cleverapps.Scenes.GetRunningScene();

    if (scene.islandDecorationChest) {
        scene.islandDecorationChest.removeFromParent();
        scene.islandDecorationChest = undefined;
    }
};
